(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["casuki-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const raiz = document.querySelector('.casuki-reviews');
    if (!raiz) return;

    const rutaHls = raiz.dataset.casukiHlsSrc;
    const esHls = (url) => /\.m3u8(\?|$)/i.test(url);

    // Safari e iOS reproducen HLS solos; Chrome, Firefox y Edge no.
    const hlsNativo = !!document.createElement('video').canPlayType('application/vnd.apple.mpegurl');

    let cargandoLibreria = null;
    const cargarLibreria = () => {
      if (!cargandoLibreria) {
        cargandoLibreria = new Promise((listo, falla) => {
          const s = document.createElement('script');
          s.src = rutaHls;
          s.onload = () => listo(window.Hls);
          s.onerror = falla;
          document.head.appendChild(s);
        });
      }
      return cargandoLibreria;
    };

    // Monta la fuente en un <video>. Solo descarga la librería si el
    // navegador la necesita de verdad.
    const montar = async (video, url, reproducir) => {
      if (!url) return;

      if (!esHls(url) || hlsNativo) {
        video.src = url;
        if (reproducir) video.play().catch(() => {});
        return;
      }

      try {
        const Hls = await cargarLibreria();
        if (!Hls || !Hls.isSupported()) return;
        const motor = new Hls({ maxBufferLength: 12 });
        motor.loadSource(url);
        motor.attachMedia(video);
        video.casukiHls = motor;
        if (reproducir) video.play().catch(() => {});
      } catch {
        // Sin video es mejor que una tarjeta rota: no se hace nada más.
      }
    };

    const soltar = (video) => {
      if (video.casukiHls) {
        video.casukiHls.destroy();
        video.casukiHls = null;
      }
      video.pause();
      video.removeAttribute('src');
      video.load();
    };

    // Vista previa de cada tarjeta.
    document.querySelectorAll('[data-casuki-video-src]').forEach((video) => {
      montar(video, video.dataset.casukiVideoSrc, true);
    });

    const cerrarDialogo = (dialog) => {
      const player = dialog.querySelector('[data-casuki-review-player]');
      if (player) soltar(player);
      if (dialog.open) dialog.close();
    };

    // Delegado en el documento porque la marquesina imprime cada video dos
    // veces y ambas copias deben responder al clic.
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-casuki-review-video]');

      if (trigger) {
        const dialog = trigger.closest('.casuki-reviews').querySelector('[data-casuki-review-dialog]');
        const player = dialog.querySelector('[data-casuki-review-player]');
        soltar(player);
        dialog.showModal();
        montar(player, trigger.dataset.casukiReviewVideo, true);
        return;
      }

      if (event.target.closest('[data-casuki-review-close]')) {
        cerrarDialogo(event.target.closest('dialog'));
        return;
      }

      const abierto = event.target.closest('.casuki-review__dialog');
      if (abierto && event.target === abierto) cerrarDialogo(abierto);
    });

    // Escape lo cierra el navegador por su cuenta; aquí solo se aprovecha el
    // aviso para detener el video antes de que desaparezca.
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('dialog[open][data-casuki-review-dialog]').forEach(cerrarDialogo);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
